import { Form, Input, Modal, ModalProps } from "@gw/web-basic-components";
import React, { useEffect, useRef, useState } from "react";

const useFormModal = (
  props: Omit<ModalProps, "children" | "open" | "onOk" | "onCancel">
) => {
  const [items, setItems] = useState<{ key: string; label: string }[]>([]);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const cbRef = useRef<{
    onOk: (values: Record<string, string>) => void;
    onCancel: () => void;
  }>({ onOk: () => {}, onCancel: () => {} });

  useEffect(() => {
    form.resetFields();
  }, [items]);

  const element = (
    <Modal
      {...props}
      okText="确定"
      cancelText="取消"
      open={open}
      onOk={() => {
        form.validateFields().then((values) => {
          cbRef.current.onOk(values);
          setOpen(false);
        });
      }}
      onCancel={() => {
        cbRef.current.onCancel();
        setOpen(false);
      }}
    >
      <Form form={form} initialValues={{}} className="wbuc-p-5" autoFocus>
        {items.map((item) => (
          <Form.Item
            key={item.key}
            name={item.key}
            label={item.label}
            rules={[{ required: true, message: `请输入${item.label}` }]}
          >
            <Input
              placeholder={`请输入${item.label}`}
              size="small"
              maxLength={40}
              allowClear
              autoFocus
            />
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );

  const openModal = (opts: typeof items) => {
    setItems(opts);
    setOpen(true);
    return new Promise<Record<string, string>>((resolve, reject) => {
      cbRef.current = {
        onOk: resolve,
        onCancel: reject,
      };
    });
  };

  return [element, openModal] as const;
};

export default useFormModal;
